import React from 'react';
import GiftFormatSelector from '../GiftFormatSelector';

const GiftTypeStep = ({ pageData, setPageData, theme }) => (
  <section id="gift-builder-type" className="scroll-mt-6 space-y-5">
    <div className="lumirae-editor-panel p-5">
      <div className="text-[10px] font-black uppercase tracking-[0.28em]" style={{ color: theme.accent }}>
        Step 2 / Opening Flow
      </div>
      <p className="mt-2 text-xs font-medium leading-relaxed opacity-60">
        Choose this after the chapter content feels right. It controls how the recipient moves through the gift.
      </p>
    </div>

    <GiftFormatSelector pageData={pageData} setPageData={setPageData} theme={theme} />
  </section>
);

export default GiftTypeStep;
